import { atom } from "jotai";

/**
 * 全局通知权限弹窗状态
 * onComplete: 用户授权/跳过后的回调
 */
interface NotificationModalState {
  open: boolean;
  onComplete?: () => void;
}

export const notificationModalAtom = atom<NotificationModalState>({
  open: false,
});
